import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import shouldBeLoggedIn from '#app/guards/should-be-logged-in'
import shouldMatchRole from '#app/guards/should-match-role'
import SupportDataProvider from '#app/middlewares/providers/support-data'
import router from '#app/router'
import { SomethingWentWrong } from '#pages/common/something-went-wrong'
import { ModalsLayout } from '#widgets/layouts/modals-layout'
import { NavigatableLayout } from '#widgets/layouts/navigatable-layout'
import { NotificationsLayout } from '#widgets/layouts/notifications-layout'
import { combinePaths } from '#shared/lib/strings'

export const Route = createFileRoute('/support')({
  component: () => (
    <SupportDataProvider>
      <ModalsLayout>
        <NavigatableLayout>
          <NotificationsLayout>
            <Outlet />
          </NotificationsLayout>
        </NavigatableLayout>
      </ModalsLayout>
    </SupportDataProvider>
  ),

  loader: async () => {
    await shouldBeLoggedIn()
    await shouldMatchRole('support', 'manager')

    const currentPathname = router.state.location.pathname

    // Make redirects only if current path is /support
    if (currentPathname !== combinePaths(router.basepath, '/support')) {
      return
    }

    throw redirect({ to: '/support/payouts' })
  },

  errorComponent: () => <SomethingWentWrong withHardReload />,
})
